import { render, staticRenderFns } from "./bimCalendar.vue?vue&type=template&id=37d0acf7&scoped=true&"
import script from "./bimCalendar.vue?vue&type=script&lang=js&"
export * from "./bimCalendar.vue?vue&type=script&lang=js&"
import style0 from "./bimCalendar.vue?vue&type=style&index=0&id=37d0acf7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d0acf7",
  null
  
)

export default component.exports